<template>
  <div class="preview-qrcode-layout">
    <el-image class="preview-qrcode" :src="path"></el-image>
    <div class="preview-scan-title">打开抖音扫一扫</div>
    <div class="preview-scan-tips">商品在抖音橱窗上的展示效果如扫码所见</div>
    <div v-if="type === 'course'" class="preview-scan-tabs">
      <div
        @click="tabIndex = 0"
        class="tab-item"
        :class="{ active: tabIndex === 0 }"
      >
        扫码预览
      </div>
      <div
        @click="tabIndex = 1"
        class="tab-item"
        :class="{ active: tabIndex === 1 }"
      >
        课程挂载
      </div>
    </div>
    <div v-if="tabIndex === 0" class="preview-tips">
      <div class="preview-tip-item">
        <div class="tip-item-text">打开抖音，点击“搜索”入口</div>
        <el-image
          class="tip-item-img"
          src="https://cdn-hz.renrenjiang.cn/teacher_center/website/docimgs/XfQfp.jpg"
        ></el-image>
      </div>
      <div class="preview-tip-item">
        <div class="tip-item-text">搜索页，点击“扫一扫”入口</div>
        <el-image
          class="tip-item-img"
          src="https://cdn-hz.renrenjiang.cn/teacher_center/website/docimgs/Xf1Qfp2.png"
        ></el-image>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: "",
      tabIndex: 0,
    };
  },
  props: {
    qrcode: String,
    type: {
      type: String,
      default: "",
    },
  },
  created() {
    this.loadQrcode();
  },
  methods: {
    async loadQrcode() {
      this.path =
        "https://api.renrenjiang.cn/api/v3/tt/qrcode?path=" + this.qrcode;
    },
  },
};
</script>

<style lang="scss">
.preview-qrcode-layout {
  display: flex;
  flex-direction: column;
  align-items: center;

  .preview-qrcode {
    width: 129px;
    height: 129px;
    padding: 10px;
    box-sizing: border-box;
  }

  .preview-scan-title {
    color: #090909;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
  }

  .preview-scan-tips {
    color: #acacac;
    font-size: 12px;
    line-height: 16px;
    margin-top: 6px;
  }

  .preview-tips {
    width: 100%;
    background: #f7f7f7;
    border-radius: 4px;
    margin-top: 25px;
    padding: 32px 0;

    display: flex;
    flex-direction: column;
    align-items: center;

    .preview-tip-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 32px;

      .tip-item-text {
        color: #090909;
        font-size: 14px;
        line-height: 20px;

        padding-left: 8px;
        position: relative;

        &::after {
          content: "";
          position: absolute;
          left: 0;
          top: 5px;
          width: 3px;
          height: 10px;
          border-radius: 2px;
          background-color: #0366ff;
        }
      }

      .tip-item-img {
        width: 230px;
        height: 230px;
        margin-top: 16px;
        border-radius: 8px;
      }
    }
  }
}

.preview-scan-tabs {
  display: flex;
  align-items: center;
  margin-top: 20px;
  border-bottom: 1px solid #f7f8fa;

  .tab-item {
    height: 34px;
    padding: 6px 0;
    box-sizing: border-box;
    margin-right: 25px;

    position: relative;
    display: inline-block;
    line-height: 22px;
    font-size: 14px;
    color: #686767;
    cursor: pointer;
    transition: all 0.3s;

    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 50%;
      width: 0;
      height: 3px;
      border-radius: 2px;
      background-color: #0366ff;
      transition: all 0.3s;
    }

    &:hover {
      color: #0366ff;
    }

    &.active {
      color: #0366ff;

      &::after {
        left: 0;
        width: 100%;
      }
    }
  }
}
</style>
